import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Alert, Button, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Add } from "@mui/icons-material";

import { ActivationCard, CreateNewCard } from "@/components/atoms";
import { PageContainer } from "@/components/containers";
import { useAudienceContext } from "@/context";
import { useActivations } from "@/hooks";
import { Activation } from "@/types";
import { defaultActivation } from "@/utils";
import { ActivationListSkeleton } from "./ActivationListSkeleton";

const ActivationListPage: React.FC = () => {
  const { dispatch } = useAudienceContext();
  const navigate = useNavigate();

  const { activations, loading, error } = useActivations();
  const [rows, setRows] = useState<Activation[]>([]);

  useEffect(() => {
    if (activations) setRows([defaultActivation, ...activations]);
  }, [activations]);

  const handleCreate = () => {
    dispatch({ type: "CREATE_ACTIVATION" });
    navigate("new");
  };

  const handleSelect = (activation: Activation) => {
    dispatch({ type: "GET_ACTIVATION", payload: activation });
    navigate(activation.campaign_id);
  };

  const actionButtons = (
    <Stack direction="row" spacing={2}>
      <Button
        variant="contained"
        size="small"
        disableElevation
        startIcon={<Add />}
        onClick={handleCreate}
      >
        Create New
      </Button>
    </Stack>
  );

  return (
    <PageContainer actions={actionButtons}>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Typography>My Activations</Typography>
        </Grid>

        <Grid container size={12}>
          {loading ? (
            <ActivationListSkeleton />
          ) : error ? (
            <Grid>
              <Alert variant="filled" severity="error">
                It was not possible to load your activations at this time,
                please try again.
              </Alert>
            </Grid>
          ) : (
            rows.map((activation, index) => (
              <Grid key={index}>
                {index === 0 ? (
                  <CreateNewCard
                    title="Create New Activation"
                    onClick={handleCreate}
                  />
                ) : (
                  <ActivationCard
                    activation={activation}
                    onEdit={handleSelect}
                  />
                )}
              </Grid>
            ))
          )}
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default ActivationListPage;
